<template>
    <div>
        <SOSlotCard
            :card-type="'box'"
            :dropdown-menu="'card'"
            class="p-d-8"
        >
            <template v-slot:card_head>
                <div class="top-card">
                    <div class="f-regular f-16 f-c-black">
                        {{ title }}
                    </div>
                    <div class="card-menu-vertical"></div>
                </div>
            </template>
            <template v-slot:card_body>
                <!-- <div class="f-regular f-14 f-c-midgrey" v-if="data.sending_time !== null"> -->
                    <!-- <span v-if="data.idcountdown_master !== 1">
                        Dikirim pukul {{ data.sending_time.substr(0, 5) }} WIB
                    </span> -->
                <!-- </div> -->
            </template>
            <template v-slot:menu_card>
                <button class="dropdown-item icon-2" @click="onChange()">
                    <span class="mar-right-10">
                        <img src="@/assets/icons/edit_2.svg" />
                    </span>
                    Ubah
                </button>
                <button class="dropdown-item icon-2" @click="onDelete()">
                    <span class="mar-right-10">
                        <img src="@/assets/icons/trash-red.svg" />
                    </span>
                    Hapus
                </button>
            </template>
        </SOSlotCard>
    </div>
</template>
<script>
import SOSlotCard from '@/so-components/global/slot/SOSlotCard.vue'
export default {
    name: 'SOCardReminder',
  components: { SOSlotCard },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    onChange() {
        this.$emit('change')
    },
    onDelete() {
        this.$emit('delete')
    },
  }
}
</script>